import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

// Ödüllü video yalnızca mobil uygulamada (native köprü varsa) gösterilir; web'de gizli.
export const hasRewardedAds = () =>
  typeof window !== 'undefined' && !!(window.text2Ads && window.text2Ads.supported);

export const useRewardedAds = () => {
  const [supported, setSupported] = useState(hasRewardedAds);
  const [status, setStatus] = useState(null);
  const [watching, setWatching] = useState(null);

  useEffect(() => {
    if (supported) return undefined;
    const onReady = () => setSupported(hasRewardedAds());
    window.addEventListener('text2-ads-ready', onReady);
    return () => window.removeEventListener('text2-ads-ready', onReady);
  }, [supported]);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get('/api/ads/status');
      if (res.data?.success) setStatus(res.data);
    } catch (_) {
      /* yoksay */
    }
  }, []);

  useEffect(() => {
    if (supported) refresh();
  }, [supported, refresh]);

  // Bir yerde video izlenince diğer düğmeler (görev düğmesi vb.) de sayıyı günceller.
  useEffect(() => {
    if (!supported) return undefined;
    window.addEventListener('text2-ads-changed', refresh);
    return () => window.removeEventListener('text2-ads-changed', refresh);
  }, [supported, refresh]);

  const watch = useCallback(async (purpose) => {
    if (!hasRewardedAds() || watching) return { success: false };
    setWatching(purpose);
    try {
      const start = await axios.post('/api/ads/start', { purpose });
      if (!start.data?.success) return { success: false, message: start.data?.message };
      const result = await window.text2Ads.showRewarded();
      if (!result?.earned) return { success: false, message: result?.error || '' };
      const claim = await axios.post('/api/ads/claim', { nonce: start.data.nonce });
      if (claim.data?.success) {
        setStatus(claim.data);
        window.dispatchEvent(new CustomEvent('text2-ads-changed'));
      }
      return claim.data || { success: false };
    } catch (_) {
      return { success: false };
    } finally {
      setWatching(null);
    }
  }, [watching]);

  return { supported, status, watching, watch, refresh };
};

// Bugün izlenebilecek ama henüz izlenmemiş ödüllü (Ruh) video sayısı; desteklenmiyorsa 0.
export const pendingRuhVideos = (ads) => {
  if (!ads?.supported || !ads.status) return 0;
  const limit = ads.status.limits?.ruh ?? 0;
  const count = ads.status.counts?.ruh ?? 0;
  return Math.max(0, limit - count);
};

export const adBoostRemaining = (until) => {
  const left = Math.max(0, Number(until || 0) - Math.floor(Date.now() / 1000));
  if (left <= 0) return '';
  const m = Math.floor(left / 60);
  const s = left % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};
